import { render, staticRenderFns } from "./StaffStatus.vue?vue&type=template&id=db049a54&"
import script from "./StaffStatus.vue?vue&type=script&lang=js&"
export * from "./StaffStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports